import { customerFragment } from '../fragments'

export const getCustomerByIdQuery = /* GraphQL */ `
  query GetCustomerById($id: ID!) {
    getCustomer(id: $id) {
      ...CustomerFragment
    }
  }
  ${customerFragment}
`

export const customersByOrganizationQuery = /* GraphQL */ `
  query CustomersByOrganization(
    $organizationID: ID!
    $filter: ModelCustomerFilterInput
  ) {
    customersByOrganization(organizationID: $organizationID, filter: $filter) {
      items {
        ...CustomerFragment
      }
    }
  }
  ${customerFragment}
`

export const createCustomerMutation = /* GraphQL */ `
  mutation CreateCustomer($input: CreateCustomerInput!) {
    createCustomer(input: $input) {
      id
      createdAt
    }
  }
`

export const updateCustomerMutation = /* GraphQL */ `
  mutation UpdateCustomer($input: UpdateCustomerInput!) {
    updateCustomer(input: $input) {
      id
      updatedAt
    }
  }
`

export const deleteCustomerByIdMutation = /* GraphQL */ `
  query DeleteCustomerById($id: ID!) {
    deleteCustomer(id: $id) {
      id
      deletedAt
    }
  }
`
